import {inject} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {catchError, map, mergeMap} from "rxjs/operators";
import {of} from "rxjs";
import {stationFollowerActions} from "./station-follower.actions";
import {StationFollowerRepo} from "src/app/repositories/station-follower-repo";
import {UserSummary} from "src/swagger-gen/web-secured/models/user-summary";

export class StationFollowerEffect {
  private readonly actions$ = inject(Actions);
  private readonly stationFollowerRepo = inject(StationFollowerRepo);

  fetchData$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(stationFollowerActions.searchByStations),
      mergeMap(action => {
        return this.stationFollowerRepo.searchStationsFollowers({ uids: action.stationUids })
          .pipe(
            map(response => {
              const followersSummaryMap = response.reduce((accumulator, currentValue) => {
                accumulator.set(currentValue?.uid, currentValue.followers);
                return accumulator;
              }, new Map<string, Array<UserSummary>>());

              return stationFollowerActions.fetchSuccess({ data: followersSummaryMap });
            }),
            catchError(error => of(stationFollowerActions.fetchFailure({ message: error?.toString() })))
          )
      }),
    );
  });
}
